import { Text } from '@joor/design-system'
import styled from 'styled-components'

import messages from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.messages'
import useStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

const Container = styled.div`
  width: 75%;
  height: 100%;
  align-content: center;
`

const ProgressBar = styled.div`
  background-color: var(--color-secondary-100);
  border-radius: 5px;
  height: 5px;
  overflow: hidden;
  width: 100%;
`

const Fill = styled.div<{ progress: number }>`
  background-color: var(--color-secondary-500);
  height: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s ease-in-out;
  width: ${(props) => props.progress}%;
`

const ImageUpload = (): JSX.Element => {
  const uploadProgress = useStore((state) => state.uploadProgress)
  return (
    <Container>
      <ProgressBar>
        <Fill progress={uploadProgress} />
      </ProgressBar>
      <br />
      <Text fontWeight="medium" letterSpacing="tighter" textAlign="center">
        {messages.uploadingImages}
      </Text>
    </Container>
  )
}

export default ImageUpload
